import ChatPanel from './ChatPanel';
export default ChatPanel;
